import { createAsyncThunk } from '@reduxjs/toolkit';

import { CountryResidenceService, UserSettingsService } from 'api';

export const uploadTaxDocuments = createAsyncThunk(
	'userSettings/uploadTaxDocuments',
	async (credentials: any, { rejectWithValue }) => {
		try {
			await CountryResidenceService.uploadDocument(credentials);
			return await UserSettingsService.get();
		} catch (e: any) {
			return rejectWithValue(e?.response.data);
		}
	},
);
